// removed by extract-text-webpack-plugin
module.exports = {"flex-start":"alignItems__flex-start___1GlNL alignItems-flexStart","flex-end":"alignItems__flex-end___VnOFT alignItems-flexEnd","center":"alignItems__center___2bDs8 alignItems-center","baseline":"alignItems__baseline___JSPkg alignItems-baseline","stretch":"alignItems__stretch___pQcas alignItems-stretch"};


//////////////////
// WEBPACK FOOTER
// ./packages/marvel-ui-grid/Grid/style/alignItems.css
// module id = 45
// module chunks = 0 1 6